import React from 'react'
import {
  Flex,
  FlexItem,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_DANGER,
  Button
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import { modalConfirmDiscardState, pageState } from '../recoil/state/state'
import {
  useRecoilCallback,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState
} from 'recoil'
import { saveCallback } from '../recoil/callbacks/callbacks'
import ModalConfirmDiscard from './ModalConfirmDiscard'

const Footer = () => {
  const intl = useIntl()
  const { isEnabled } = useRecoilValue(pageState)
  const [{ show }, setModalConfirm] = useRecoilState(modalConfirmDiscardState)
  const save = useRecoilCallback(saveCallback, [])

  const onClickSave = e => {
    save()
  }

  return (
    <>
      <ModalConfirmDiscard show={show} />
      <Flex justifyContent='flex-end'>
        <FlexItem>
          <Button
            kind={BUTTON_VARIANT_PRIMARY}
            onClick={onClickSave}
            data-mu-test='save'
            disabled={!isEnabled}
          >
            {intl.formatMessage({ id: 'Load.MailupCommon.Save' })}
          </Button>
          <Button
            kind={BUTTON_VARIANT_DANGER}
            onClick={() => setModalConfirm(prev => ({ prev, show: true }))}
            data-mu-test='discard'
            disabled={!isEnabled}
          >
            {intl.formatMessage({ id: 'Load.ContentDefaults.Reset' })}
          </Button>
        </FlexItem>
      </Flex>
    </>
  )
}

export default Footer
